module.exports = __webpack_public_path__ + "assets/img/0fe980c876781d05c9c22a82fc274d2c.svg";